import { styled } from '@mui/material/styles';
import { AccordionDetails, AccordionProps, Box, Typography } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary, { accordionSummaryClasses, AccordionSummaryProps } from '@mui/material/AccordionSummary';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Skeleton from '@mui/material/Skeleton';
import BookingDeviceItem from './BookingDeviceItem';
import { RequestStatusEnum } from '@shared/types';
import { BookingCalendarDevicesListProps } from '@pages/booking/components/BookingCalendarDevicesList';

const Accordion = styled((props: AccordionProps) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
    () => ({
        position: 'relative',
        '&::before': {
            display: 'none',
        },
    }),
);

const AccordionSummary = styled((props: AccordionSummaryProps) => <MuiAccordionSummary {...props} />)(({ theme }) => ({
    position: 'sticky',
    top: 0,
    zIndex: 1,
    minHeight: 40,
    background: theme.palette.mode === 'light' ? '#F5F5F5' : '#101626',
    flexDirection: 'row-reverse',
    [`& .${accordionSummaryClasses.content}`]: {
        margin: theme.spacing(1),
    },
}));

interface BookingDeviceAccordionProps extends BookingCalendarDevicesListProps {}

const BookingDeviceAccordion: FC<BookingDeviceAccordionProps> = ({
    devices,
    getDevicesStatus,
    devicesType,
    selectedDeviceId,
    setSelectedDeviceId,
}) => {
    const { t } = useTranslation();

    return (
        <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
                <Typography fontWeight={700} fontSize="1rem" component="span">
                    {t(`${devicesType}_accordion_title`)}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
                {getDevicesStatus === RequestStatusEnum.Loading && (
                    <Box sx={{ p: 2, height: 80 }}>
                        <Skeleton animation="wave" height={15} />
                        <Skeleton animation="wave" height={15} />
                        <Skeleton animation="wave" height={15} />
                    </Box>
                )}
                {getDevicesStatus === RequestStatusEnum.Success &&
                    devices &&
                    devicesType &&
                    devices[devicesType].map((device) => (
                        <BookingDeviceItem
                            key={device.pk}
                            device={device}
                            selectedDeviceId={selectedDeviceId}
                            setSelectedDeviceId={setSelectedDeviceId}
                        />
                    ))}
            </AccordionDetails>
        </Accordion>
    );
};

export default BookingDeviceAccordion;
